import { getAxiosInstance, requestConfig } from "../../http-common";
import { CreateSystemRequest } from "../../models/system/CreateSystemRequest";
import { System } from "../../models/system/System";
import { UpdateSystemRequest } from "../../models/system/UpdateSystemRequest";

const RESOURCE_NAME = 'systems';

const getAll = () => {
  const http = getAxiosInstance();
  return http.get<System[]>(`${RESOURCE_NAME}`, requestConfig());
};

const create = (model: CreateSystemRequest) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}`, model, requestConfig());
};

const update = (id: number, model: UpdateSystemRequest) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/${id}`, model, requestConfig());
};

const remove = (id) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/${id}`, requestConfig());
};

const ReportService = {
  getAll,
  create,
  update,
  remove
};
export default ReportService;
